import PrivateRoute, { Router } from '@Components/app-layout/PrivateRoute';

import IntegrationsGrid from '../components/Grid';
import SweepFinishedGrid from '../components/SweepFinishedGrid';
import Unsubscribe from '../components/Unsubscribe';
import { IntegrationProvider } from '../store';

export default function IntegrationsGridLayout() {
  return <IntegrationProvider>
    <IntegrationsGrid />
    <Router>
      <PrivateRoute path="/settings/integrations/unsubscribe" component={Unsubscribe} />
      <PrivateRoute path={["/settings/integrations/sweep/finished", "/settings/integrations/sweep/:id/finished"]} component={SweepFinishedGrid} />
    </Router>
  </IntegrationProvider>;
}
